import { Reveal } from "./Reveal";

export const SectionHeading = ({ overline, title, text, dark = false, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <p
        className={`text-xs uppercase tracking-[0.28em] font-display font-semibold ${
          dark ? "text-amber-700" : "text-amber-400"
        }`}
      >
        {overline}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`mt-4 font-serif font-semibold tracking-tight leading-[1.12] text-3xl sm:text-4xl lg:text-5xl ${
          dark ? "text-[#0B1D16]" : "text-emerald-50"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {text && (
      <Reveal delay={0.16}>
        <p
          className={`mt-5 text-base sm:text-lg leading-relaxed font-light ${
            dark ? "text-[#0B1D16]/70" : "text-slate-300/90"
          }`}
        >
          {text}
        </p>
      </Reveal>
    )}
  </div>
);
